import { baseUrl } from '../tokens'

export default `
@font-face {
    font-family: Bryant;
    font-weight: 400;
    src: url('${baseUrl}fonts/bryant/bryant-regular.woff2') format('woff2'),
         url('${baseUrl}fonts/bryant/bryant-regular.woff') format('woff');
}

@font-face {
    font-family: Bryant;
    font-weight: 600;
    src: url('${baseUrl}fonts/bryant/bryant-semibold.woff2') format('woff2'),
         url('${baseUrl}fonts/bryant/bryant-semibold.woff') format('woff');
}

@font-face {
    font-family: Bryant;
    font-weight: 700;
    src: url('${baseUrl}fonts/bryant/bryant-bold.woff2') format('woff2'),
         url('${baseUrl}fonts/bryant/bryant-bold.woff') format('woff');
}

@font-face {
    font-family: 'Open Sans';
    font-weight: 400;
    src: url('${baseUrl}fonts/opensans/opensans-regular.woff2') format('woff2'),
         url('${baseUrl}fonts/opensans/opensans-regular.woff') format('woff');
}

@font-face {
    font-family: 'Open Sans';
    font-weight: 600;
    src: url('${baseUrl}fonts/opensans/opensans-semibold.woff2') format('woff2'),
         url('${baseUrl}fonts/opensans/opensans-semibold.woff') format('woff');
}
`
